import { Component, OnInit, Input } from '@angular/core';
import { CoolingSystem } from '../../model/interfaces';
import { CvdsUtilsService } from '../../service';
import { CoolingSystemLayout } from '../../model/layout';

@Component({
	selector: 'cv-cvds-cooling-system',
	templateUrl: './cvds-cooling-system.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsCoolingSystemComponent implements OnInit {
	@Input() cooling: CoolingSystem;
	@Input() index: number;

	constructor(private utilsService: CvdsUtilsService) {}

	fieldsModel = [];
	fieldsSections = [];

	async ngOnInit(): Promise<void> {
		const layout = new CoolingSystemLayout();
		this.fieldsModel = this.utilsService.mapFields(this.cooling, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.cooling, fieldName)) {
				this.fieldsSections.push({
					items: this.cooling[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
